import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "../scss/Contact.scss";
import { motion } from "framer-motion";
import { submitContactUs } from "../services/api";

const ContactUs = () => {
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [subject,setSubject] = useState();
  const [message, setMessage] = React.useState("");

  const [formMsg, setFormMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const expert = {
      email,
      phone,
      name: firstName + " "+ lastName,
      subject,
      message,
    };
    
    try {
      setLoading(true);
      const response = await submitContactUs(expert);

      if(response.success){
        console.log('res', response);
        setFormMsg({ success: true, msg: response.msg});
        setLoading(false);

        setTimeout(() => {
          setFormMsg(null);
          setEmail('');
          setFirstName('');
          setLastName('');
          setPhone('');
          setSubject('');
          setMessage('');
        }, 2000);
      }
    }
    catch(err) {
      console.log("Error", err);
      if(err.response && err.status == 422) {
        setFormMsg({ success: false, msg: err.response.data.errors[0].message});
      } else {
        setFormMsg({ success: false, msg: err.message});
      }
      setLoading(false);
    }
  };
  return (
    <div className="contact-page">
      <section className="flex justify-center items-center py-8 mt-8 w-full max-md:px-5 max-md:mt-5 max-md:max-w-full lg:mb-32 max-md:mb-16">
        <motion.form
          initial={{ opacity: 0, scale: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
          viewport={{ once: true }} 
          className="flex flex-col self-stretch px-5 w-full lg:w-1/2 form"
          onSubmit={(e) => handleSubmit(e)}
        >
          <div className="text-5xl font-medium light-title">Get in touch!</div>
          <p className="text-color font-medium">How can we help you?</p>

          { formMsg?.success == true && <span className="bg-green-100 text-green-600 p-3">{formMsg.msg}</span> }
          {
            formMsg && !formMsg.success && <span className="bg-red-200 text-red-700 p-3">{formMsg?.msg}</span>
          }

          <div className="mt-8 w-full max-md:max-w-full">
            <div className="flex gap-5 max-md:flex-col max-md:gap-0">
              <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                <div className="text-lg font-medium text-color max-md:mt-8">
                  First Name
                </div>
                <input
                  type="text"
                  placeholder=""
                  name="FirstName"
                  className="box-border flex relative flex-col shrink-0 p-2.5 mt-5 rounded-md border-solid"
                  required
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
              <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                <div className="flex flex-col grow max-md:mt-8">
                  <div className="text-lg font-medium text-color">
                    Last Name
                  </div>
                  <input
                    type="text"
                    placeholder=""
                    name="LastName"
                    className="box-border flex relative flex-col shrink-0 p-2.5 mt-5 rounded-md"
                    required
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-8 w-full max-md:max-w-full max-sm:mt-0">
            <div className="flex gap-5 max-md:flex-col max-md:gap-0">
              <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                <div className="flex flex-col grow text-lg font-medium text-color whitespace-nowrap max-md:mt-8">
                  <div>Email</div>
                  <input
                    type="email"
                    placeholder=""
                    name="Email"
                    className="box-border flex relative flex-col shrink-0 p-2.5 mt-5 rounded-md"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>
              <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                <div className="flex flex-col grow text-lg font-medium text-color max-md:mt-8">
                  <div>Contact Number</div>
                  <PhoneInput
                    className="box-border flex relative flex-col shrink-0 p-1.5 mt-5 rounded-md border-2 border-solid"
                    inputStyle={{ borderStyle: "none", width: "inherit" }}
                    dropdownStyle={{
                      borderStyle: "solid",
                      border: 1,
                      borderColor: "#6369C4",
                      backgroundColor: "#fff",
                    }}
                    buttonStyle={{
                      borderStyle: "none",
                      border: 0,
                      backgroundColor: "#fff",
                    }}
                    required
                    country={"us"}
                    value={phone}
                    onChange={(ph) => setPhone(ph)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 w-full text-lg font-medium text-color max-md:mt-10 max-md:max-w-full max-sm:mt-8">
            Subject
          </div>
          <input
            name="subject"
            className="box-border flex relative flex-col shrink-0 p-3 mt-5 rounded-md border-2 border-solid"
            
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />

          <div className="mt-8 w-full text-lg font-medium text-color max-md:mt-10 max-md:max-w-full max-sm:mt-8">
            Message
          </div>
          <textarea
            name="ExperienceDetails"
            className="box-border flex relative flex-col shrink-0 px-2.5 pt-2.5 pb-28 my-5 rounded-md border-solid"
            required
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <button className="justify-center items-center self-center px-4 py-3 my-8 max-w-full text-2xl font-medium text-center dark-button text-white whitespace-nowrap rounded-lg  shadow-xl w-[300px] max-md:px-5">
            { loading ? "Submitting...": "Submit" }
          </button>
        </motion.form>
      </section>
    </div>
  );
};

export default ContactUs;








